export const ASLEEP_FEARFUL = 'asleepFearful'
export const FENDING_OFF = 'fendingOff'
export const COWGIRL = 'cowgirl'
export const BLOWJOB = 'blowjob'
